import type { ColumnHeaderMenuLabels } from './column-header-menu'

/**
 * English defaults. A localized app passes translated strings via `labels`; the DS ships English
 * so a bare consumer renders something sensible (mirrors `VisibilityMenu`'s `label`).
 *
 * A plain `.ts` module (not `column-header-menu.tsx`) so that component file exports only its
 * component — the fast-refresh purity `only-export-components` asks for.
 */
export const DEFAULT_COLUMN_HEADER_MENU_LABELS: ColumnHeaderMenuLabels = {
  menu: 'Column options',
  sortLabel: 'Sort',
  sortAsc: 'Sort by ASC',
  sortDesc: 'Sort by DESC',
  unsort: 'Unsort',
  pinLeft: 'Pin to left',
  pinRight: 'Pin to right',
  unpin: 'Unpin',
  moveLeft: 'Move left',
  moveRight: 'Move right',
}
